import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { ProductCollection } from "@cureskin/api-client/src/server-api";

@Component({
  selector: 'app-shop-collection-nav',
  imports: [],
  templateUrl: './shop-collection-nav.component.html',
  standalone: true
})
export class ShopCollectionNavComponent {
  order: InputSignal<string[]> = input<string[]>();
  collections: InputSignal<{[key: string]: ProductCollection}> = input();
  selectedCollection: InputSignal<string> = input<string>();

  gotoCollection: OutputEmitterRef<string> = output<string>();
}
